import { render, staticRenderFns } from "./SysArea.vue?vue&type=template&id=624be243&scoped=true&"
import script from "./SysArea.vue?vue&type=script&lang=js&"
export * from "./SysArea.vue?vue&type=script&lang=js&"
import style0 from "./SysArea.vue?vue&type=style&index=0&id=624be243&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624be243",
  null
  
)

export default component.exports